import { render, staticRenderFns } from "./Galery.vue?vue&type=template&id=8d23568c&"
import script from "./Galery.vue?vue&type=script&lang=js&"
export * from "./Galery.vue?vue&type=script&lang=js&"
import style0 from "./Galery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports